function formatVisitorDays(ms) {
  const days = ms / (24 * 60 * 60 * 1000);
  if (days < 1) {
    const hours = ms / (60 * 60 * 1000);
    return hours.toFixed(1);
  }
  return days.toFixed(1);
}

export function mountStrip(presence) {
  const here = document.querySelector('[data-strip="here"]');
  const days = document.querySelector('[data-strip="days"]');
  const created = document.querySelector('[data-strip="created"]');

  let count = 0;
  let visitorMillis = 0;
  let totalCreated = 0;

  function paint() {
    if (here) here.textContent = count.toString();
    if (days) days.textContent = formatVisitorDays(visitorMillis);
    if (created) created.textContent = totalCreated.toString();
  }

  presence.on("welcome", (m) => {
    count = m.count;
    visitorMillis = m.visitorMillis;
    totalCreated = m.totalCreated;
    paint();
  });
  presence.on("presence", (m) => { count = m.count; paint(); });
  presence.on("tick",     (m) => { visitorMillis = m.visitorMillis; paint(); });
  presence.on("created",  (m) => { totalCreated = m.totalCreated; paint(); });
}
